export default function Products() {
  const products = [
    {
      name: 'VPN Solution',
      icon: 'ri-shield-keyhole-line',
      color: 'from-cyan-400 to-cyan-600',
      bgGradient: 'from-purple-900 to-purple-800',
      features: [
        'Military-grade encryption',
        'Global server network',
        'Zero-log policy',
        'Lightning-fast connection'
      ],
      image: 'https://public.readdy.ai/ai/img_res/88febb41241726e8491fa143377836d1.jpg'
    },
    {
      name: 'System Cleaner',
      icon: 'ri-brush-line',
      color: 'from-lime-400 to-lime-600',
      bgGradient: 'from-purple-900 to-purple-800',
      features: [
        'Intelligent storage analysis',
        'One-tap optimization',
        'Privacy protection',
        'Battery life enhancement'
      ],
      image: 'https://readdy.ai/api/search-image?query=Abstract%20system%20optimization%20visualization%20with%20circular%20progress%20indicator%20and%20glowing%20particles%20in%20bright%20lime%20green%20color%2C%20clean%20minimalist%20design%20showing%20performance%20boost%20concept%2C%20flowing%20energy%20waves%20with%20sparkle%20effects%2C%20modern%20tech%20illustration%20on%20dark%20purple%20gradient%20background%2C%20professional%20iOS%20cleaner%20app%20aesthetic&width=600&height=400&seq=cleaner-product-001&orientation=landscape'
    }
  ];

  return (
    <section id="products" className="py-32 bg-gray-900">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-bold text-white mb-6">Our Products</h2>
          <p className="text-xl text-gray-400">Powerful applications designed for iOS ecosystem</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10" data-product-shop>
          {products.map((product, index) => (
            <article key={index} className={`rounded-[32px] bg-gradient-to-br ${product.bgGradient} p-12 flex flex-col`}>
              <div className="mb-8 h-64 rounded-2xl overflow-hidden">
                <img 
                  src={product.image}
                  alt={`${product.name} - iOS application by PLENUS d.o.o.`}
                  title={`${product.name} iOS app`}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <h3 className="text-4xl font-bold text-white mb-8">{product.name}</h3>
              
              <ul className="space-y-4 flex-grow">
                {product.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-gray-300">
                    <i className="ri-checkbox-circle-fill text-xl" style={{ color: product.color.includes('cyan') ? '#22d3ee' : '#84cc16' }}></i>
                    <span className="text-base">{feature}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}